var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1.77552C18.3007 2.07724 17.5495 2.28028 16.761 2.37186C17.5663 1.90331 18.1838 1.16144 18.4746 0.276871C17.7219 0.710635 16.8874 1.02584 15.9988 1.19622C15.2878 0.460031 14.275 0 13.1541 0C11.0013 0 9.2563 1.69601 9.2563 3.78674C9.2563 4.08349 9.29137 4.37314 9.35714 4.6493C6.11776 4.49169 3.24595 2.98381 1.32264 0.692177C0.987962 1.2516 0.795777 1.90189 0.795777 2.5969C0.795777 3.91027 1.4834 5.06957 2.5291 5.74826C1.89043 5.72838 1.28903 5.558 0.763624 5.27474C0.763624 5.29107 0.763624 5.30598 0.763624 5.32231C0.763624 7.15746 2.10673 8.68806 3.89047 9.03521C3.56382 9.12182 3.21891 9.16797 2.86304 9.16797C2.6124 9.16797 2.3676 9.14383 2.13011 9.10052C2.62628 10.6049 4.06584 11.7003 5.77139 11.7308C4.43779 12.7467 2.75709 13.3523 0.930234 13.3523C0.616015 13.3523 0.30545 13.3345 0 13.299C1.72528 14.3731 3.77355 15 5.97527 15C13.1453 15 17.065 9.22973 17.065 4.22547C17.065 4.06148 17.0613 3.8982 17.054 3.73562C17.8162 3.20105 18.4775 2.53443 19 1.77552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.42f3b65e6711dd35f160b127eeeeb692.svg";
export { ForwardRef as ReactComponent };